import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
  Stack,
} from "@mui/material";
import {
  LockOutlined,
  FlashOnOutlined,
  PictureAsPdfOutlined,
  PeopleOutline,
  StarOutline,
} from "@mui/icons-material";
import { Helmet } from "react-helmet-async";

// existing component
import WhyChooseUs from "../components/WhyChooseUs";
import BackButton from "../components/utils/BackButton";

export default function AboutUs() {
  return (
    <Box
      sx={{
        maxWidth: 1000,
        mx: "auto",
        p: { xs: 2, md: 4 },
        bgcolor: "background.default",
      }}
    >
      <BackButton fallback="/" />
      {/* SEO */}
      <Helmet>
        <title>About Us | MarriageBiodata.live</title>
        <meta
          name="description"
          content="MarriageBiodata.live is a free, privacy-first marriage biodata maker that helps users create professional biodata instantly without signup or data storage."
        />
        <link rel="canonical" href="https://www.marriagebiodata.live/about" />
      </Helmet>

      {/* Header */}
      <Typography variant="h4" fontWeight={700} gutterBottom>
        About MarriageBiodata.live
      </Typography>

      <Typography color="text.secondary" paragraph>
        MarriageBiodata.live is a modern, browser-based marriage biodata generator
        designed to help individuals create professional and well-formatted
        biodata quickly, securely, and completely free of cost.
      </Typography>

      <Typography color="text.secondary" paragraph>
        Our tool runs entirely inside your browser, ensuring that your personal
        information remains private. No registration, login, or data storage is
        required at any stage of the biodata creation process.
      </Typography>

      <Divider sx={{ my: 4 }} />

      {/* Value Cards */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
                <FlashOnOutlined sx={{ color: "warning.main" }} />
                <Typography fontWeight={600}>Fast & Simple</Typography>
              </Stack>
              <Typography color="text.secondary" fontSize={14}>
                Create marriage biodata in minutes with an intuitive interface
                and live preview — no learning curve required.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
                <LockOutlined sx={{ color: "warning.main" }} />
                <Typography fontWeight={600}>Privacy First</Typography>
              </Stack>
              <Typography color="text.secondary" fontSize={14}>
                Your biodata stays in your browser. No login, no storage, and no
                server-side processing.
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <Card sx={{ height: "100%" }}>
            <CardContent>
              <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
                <PictureAsPdfOutlined sx={{ color: "warning.main" }} />
                <Typography fontWeight={600}>Instant PDF</Typography>
              </Stack>
              <Typography color="text.secondary" fontSize={14}>
                Download a high-quality A4 PDF instantly, ready to share with
                families and relatives.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* WHO WE ARE */}
      <Divider sx={{ my: 5 }} />

      <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
        <PeopleOutline sx={{ color: "warning.main" }} />
        <Typography variant="h6" fontWeight={600}>
          Who We Are
        </Typography>
      </Stack>

      <Typography color="text.secondary" paragraph>
        We are a small, focused team building simple and privacy-first digital
        tools. MarriageBiodata.live was created to solve a very specific problem —
        creating marriage biodata should be quick, free, and secure.
      </Typography>

      <Typography color="text.secondary" paragraph>
        We believe personal details should never be uploaded to unknown servers.
        That’s why our platform works entirely inside your browser, without
        accounts, tracking, or data storage.
      </Typography>

      {/* WHY CHOOSE US */}
      <Divider sx={{ my: 5 }} />

      <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
        <StarOutline sx={{ color: "warning.main" }} />
        <Typography variant="h6" fontWeight={600}>
          Why Choose Us
        </Typography>
      </Stack>

      <WhyChooseUs />
    </Box>
  );
}
